var applyBindings = require('./apply_bindings.js');

module.exports = function() {
  // Expose the Knockout view models so they can be used in template code.
  global.tk = global.tk || {};
  global.tk.viewModels = applyBindings.viewModels;
  global.tk.viewModelSetup = applyBindings.viewModelSetup;
  
  global.tk.Notifications = require('../notifications.js');
  global.tk.viewModels['_notifications'] = global.tk.Notifications.instance;

  $(applyBindings.init);
}
